<template>
  <div>
    <ScatterChart
      v-if="loaded"
      class=" chart"
      :style="styleChart"
      :chart-data="datacollection"
      :options="options"
    ></ScatterChart>
  </div>
</template>

<script>
import APIService from '../../APIService'
export default {
  components: {
    ScatterChart: () => import('./ScatterChart.js')
  },
  props: {
    queryId: {
      type: String,
      default: null
    },
    schema: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    xtitle: {
      type: String,
      default: null
    },
    ytitle: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    yMin: {
      type: Number,
      default: undefined
    },
    yMax: {
      type: Number,
      default: undefined
    },
    xMinTicks: {
      type: Number,
      default: 1
    },
    xMaxTicks: {
      type: Number,
      default: 10
    },
    styleChart: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loaded: false,
      allDataSet: {},
      allData: [],
      obj: [],
      count: 0,
      dataVal: [],
      items: null,
      datacollection: null,
      labels: [],
      labelsUniq: [],
      color: 'blue',
      options: {
        elements: {
          line: {
            tension: 0
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          text: this.title,
          fontSize: 15
        },
        // scales: {
        //   xAxes: [
        //     {
        //       type: 'linear',
        //       position: 'bottom'
        //     }
        //   ]
        // }
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.ytitle,
                fontStyle: 'bold',
                fontSize: 15
              },
              gridLines: {
                drawTicks: true,
                borderDash: [5, 4]
              },
              ticks: {
                beginAtZero: false,
                min: this.yMin,
                max: this.yMax,
                fontSize: 12
              }
            }
          ],
          xAxes: [
            {
              //   type: 'linear',
              position: 'bottom',
              scaleLabel: {
                display: true,
                labelString: this.xtitle,
                fontStyle: 'bold',
                fontSize: 15
              },
              gridLines: {
                drawTicks: true,
                display: false
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: this.xMaxTicks,
                minTicksLimit: this.xMinTicks,
                fontSize: 12,
                padding: 20
              }
            }
          ]
        }
      }
    }
  },

  created() {
    if (this.queryId != null) {
      APIService.getQueryData(this.queryId)
        .then((res) => {
          this.items = res.data

          this.items.forEach((element) => {
            if ((element._id && element.count) != undefined) {
              this.dataVal.push({
                x: element._id1,
                y: element.count
              })
              this.labels.push(element._id)
            }
          })
          this.labelsUniq = this.labels.filter(
            (v, i) => this.labels.indexOf(v) === i
          )

          this.allDataSet = {
            label: this.label,
            fill: false,
            borderColor: '#509EE3',
            backgroundColor: '#e6f9ff',
            data: this.dataVal
          }

          this.fillData()
          this.loaded = true
        })
        .catch((ex) => {
          console.log(ex.response)
        })
    }
  },

  mounted() {
    this.loaded = false
  },

  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labelsUniq,
        datasets: [this.allDataSet]
      }
    }
  }
}
</script>
<style scoped>
.chart {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
  padding: 10px;
}
</style>
